<template>
	<transition>
		<div
			v-show="store.state.showingAnyPopup && store.state.showDeckMenu"
			class="bg-overlay"
			@click="hideOverlay(true)"
			@mouseover="hideOverlay(false)"
		></div>
	</transition>
</template>

<script setup>
import { useStore } from 'vuex'

const emit = defineEmits(['closePopups'])
const store = useStore()
let transitionActive = false

function anyDeckLinkFocused() {
	const deckMenuLinks = document.querySelectorAll('.deck-menu a')

	return [...deckMenuLinks].some((link) => link === document.activeElement)
}

function hideOverlay(triggeredByClick) {
	if (transitionActive) return

	if (anyDeckLinkFocused()) return

	if (!triggeredByClick && !store.state.overlayHoverEnabled) return

	transitionActive = true
	emit('closePopups', true)
	store.commit('overlayHoverEnabled', true)
	store.commit('showingAnyPopup', false)

	setTimeout(() => {
		transitionActive = false
	}, 250) // Equal to transition's duration
}
</script>
